'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NoResults from './Results/NoResults.react';
import Loading from'./Results/Loading.react';
import RecipeCard from './Results/RecipeCard.react';
import FoodCard from './Results/FoodCard.react';
import PlanCard from '../Dashboard/FeaturedPlans/PlanCard.react';
import ComboCard from './Results/ComboCard.react';
import BrandCard from './Results/BrandCard.react';
import CollectionCard from './Results/CollectionCard.react';
import CategoryCard from './Results/CategoryCard.react';
import PageCard from './Results/PageCard.react';

import BoardStore from '../../stores/BoardStore';

import { fetchDocumentsById } from '../../utils/Content';

import './Results.scss';

export default class Results extends Component {
    static propTypes = {
        loading: PropTypes.bool,
        results: PropTypes.array,
        noResultsCopy: PropTypes.node,
        overrideCreateCustomButtonCopy:  PropTypes.node,
    };

    static defaultProps = {
        loading: false,
        results: [],
    };

    static contextTypes = {
        user: PropTypes.object,
        addSwapContext: PropTypes.object,
        collection_editor_recipes: PropTypes.array,
        breakpoint47em: PropTypes.bool,

        onSelectRecipe: PropTypes.func,
        onSelectCombo: PropTypes.func,
        onSelectProduct: PropTypes.func,
        onSelectFood: PropTypes.func,
        onSelectBrand: PropTypes.func,
        onSelectCollection: PropTypes.func,
        onSelectPage: PropTypes.func,
    };

    constructor(props) {
        super(props);

        const results = (props.results || []);

        this.state = {
            boards: BoardStore.getBoards(),

            results,

            workingButtonIndex: null,
        };
    }

    componentDidMount = () => {
        BoardStore.addChangeListener(this.onBoardStoreChange);
    }

    componentWillUnmount = () => {
        BoardStore.removeChangeListener(this.onBoardStoreChange);
    }

    onBoardStoreChange = () => {
        this.setState({boards: BoardStore.getBoards()});
    }

    renderResult = (result, key) => {
        const { user, onSelectRecipe, onSelectCombo, onSelectFood, onSelectBrand, onSelectCollection, onSelectPage,
                breakpoint47em, addSwapContext, collection_editor_recipes } = this.context;
        const { params: { sort_by, sort_order } } = this.props;
        const { workingButtonIndex } = this.state;

        const proxyOnSelectCombo = async (combo) => {
            const comboRecipes = [combo.main_dish, combo.side_dish];

            this.setState({workingButtonIndex: key});

            const documents = await fetchDocumentsById(comboRecipes)
            let mainDish, sideDish;

            documents.forEach(doc => {
                if (combo.main_dish === doc.uuid) {
                    mainDish = doc;
                }

                if (combo.side_dish === doc.uuid) {
                    sideDish = doc;
                }
            });

            onSelectCombo(combo, mainDish, sideDish, addSwapContext.participants, undefined, undefined, {
                organicRanking: result.organic_ranking,
                searchRanking: key + 1,
                resultType: result.result_type,
                term: this.props.searchTerm,
                sortBy: sort_by,
                sortOrder: sort_order,
            });

            this.setState({workingButtonIndex: null});
        };

        const isLogging = (addSwapContext && addSwapContext.auto_log) ? true : false;

        const { capabilities = {} } = user || {};
        let alreadyInCollection = false;

        if(collection_editor_recipes && collection_editor_recipes.length){
            alreadyInCollection = collection_editor_recipes.includes(result.uuid);
        }

        return (
            <div className="result-container" key={result.uuid}>
                {result.type === 'recipe' ?
                    <RecipeCard recipe={result}
                        sortBy={sort_by}
                        sortOrder={sort_order}
                        organicRanking={result.organic_ranking}
                        searchRanking={key+1}
                        searchTerm={this.props.searchTerm}
                        isLogging={isLogging}
                        shortMode={!breakpoint47em}
                        alreadyInCollection={alreadyInCollection}/>
                : null}

                {result.type === 'plan'   ?
                    <PlanCard plan={result}
                        showFavorites={result.links && result.links.self ? true : false}
                        showAdvancedMode={true}
                        shortMode={!breakpoint47em}
                        isSearchResult={true} />
                : null}

                {result.type === 'combo' ?
                    <ComboCard combo={result} sortBy={sort_by} sortOrder={sort_order}
                        organicRanking={result.organic_ranking}
                        searchRanking={key+1}
                        searchTerm={this.props.searchTerm}
                        isLogging={isLogging}
                        shortMode={!breakpoint47em} />
                : null}

                {result.type === 'food' ?
                    <FoodCard food={result}
                        sortBy={sort_by}
                        sortOrder={sort_order}
                        organicRanking={result.organic_ranking}
                        searchRanking={key+1}
                        searchTerm={this.props.searchTerm}
                        isLogging={isLogging}
                        shortMode={!breakpoint47em} />
                : null}

                {result.type === 'brand' ?
                    <BrandCard brand={result} isLogging={isLogging} />
                : null}

                {result.type === 'collection' ?
                    <CollectionCard collection={result} isLogging={isLogging} />
                : null}

                {result.type === 'category' ?
                    <CategoryCard category={result} />
                : null}

                {result.type === 'page' ?
                    <PageCard page={result} />
                : null}

                {result.type === 'recipe' && onSelectRecipe ?
                    <footer>
                        {!alreadyInCollection
                            ? <button onClick={() => onSelectRecipe(result, addSwapContext.participants, undefined, {organicRanking: result.organic_ranking, sortBy: sort_by, sortOrder: sort_order, searchRanking: key+1, term: this.props.searchTerm})}>
                                select
                                {(result.protection !== 'public' && !capabilities.meal_planner) ? <i className="icon-lock" /> : null}
                              </button>
                            : <span className="already-in-collection"><i className="icon-check"/><p>Already in Collection</p></span>
                        }
                    </footer>
                : null}

                {result.type === 'collection' && onSelectCollection ?
                    <footer>
                        <button onClick={() => onSelectCollection(result)}>select</button>
                    </footer>
                : null}

                {result.type === 'combo' && onSelectCombo ?
                    <footer>
                        <button onClick={() => proxyOnSelectCombo(result)} disabled={workingButtonIndex == key}>
                            {workingButtonIndex === key
                                ? <i className="icon-spinner2" />
                                : 'select'}
                            {(result.protection !== 'public' && !capabilities.meal_planner) ? <i className="icon-lock" /> : null}
                        </button>
                    </footer>
                : null}

                {result.type === 'food' && onSelectFood ?
                    <footer>
                        <button onClick={() => onSelectFood(result, undefined, undefined, undefined, undefined, undefined, {organicRanking: result.organic_ranking, sortBy: sort_by, sortOrder: sort_order, searchRanking: key+1, term: this.props.searchTerm})}>
                            select
                            {!capabilities.meal_planner ? <i className="icon-lock" /> : null}
                        </button>
                    </footer>
                : null}

                {result.type === 'brand' && onSelectBrand ?
                    <footer>
                        <button onClick={() => onSelectBrand(result)}>select</button>
                    </footer>
                : null}

                {result.type === 'page' && onSelectPage ?
                    <footer>
                        <button onClick={() => onSelectPage(result)}>select</button>
                    </footer>
                : null}
            </div>
        );
    }

    render() {
        const { params, loaded, loading, results, noResultsCopy, loadingMessage, hideCreateCustom, overrideCreateCustomButtonCopy } = this.props;

        return (
            <div className="global-search-results">
                {loaded && !loading && !(results && results.length) ?
                    <NoResults overrideCreateCustomButtonCopy={overrideCreateCustomButtonCopy} hideCreateCustom={hideCreateCustom} noResultsCopy={noResultsCopy} params={params} />
                : null}


                {!loading && results.map(this.renderResult)}



                {loading ?
                    <Loading loadingMessage={loadingMessage} />
                : null}
            </div>
        );
    }
}
